export default {
    START_TIME_MORE_THAN_END: "Start time couldn't be more than end-time",
    CHECK_START_TIME: 'Please check start time',
    CHECK_END_TIME: 'Please check end time',
    MAXIMUM_DURATION: 'Maximum duration is ',
    SELECT_ANY_PANE: 'Select any pane',
    CAMERA_IS_NOT_AVAILABLE: 'Select a camera',
    NOT_ENOUGH_RIGHTS_EXPORT_VIDEO: 'Not enought rights to export video',
    NOT_ENOUGH_RIGHTS_EXPORT_BOOKMARK: 'Not enought rights to create bookmark',
    SELECT_BOOKMARK_TO_UPDATE: 'Select a bookmark to update',
    SELECT_BOOKMARK_TO_DELETE: 'Select a bookmark to delete',
    SET_BOOKMARK_INSIDE_TIMEBOUNDS: 'Set bookmark inside existing time range'
}